/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspage_Error_Target_Page1Inputs */

const vi_cmspage_error_target_page1 = /** @type {(inputs: Cmspage_Error_Target_Page1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang "${i?.slug}" chưa đăng hoặc không tồn tại — chọn trang khác cho liên kết.`)
};

/**

* @param {Cmspage_Error_Target_Page1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_error_target_page1 = /** @type {((inputs: Cmspage_Error_Target_Page1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Error_Target_Page1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_error_target_page1(inputs)
});
export { cmspage_error_target_page1 as "cmsPage_error_target_page" }